import { render, staticRenderFns } from "./rp-users-datasources-list-cruds.vue?vue&type=template&id=0aa50926"
import script from "./rp-users-datasources-list-cruds.vue?vue&type=script&lang=js"
export * from "./rp-users-datasources-list-cruds.vue?vue&type=script&lang=js"
import style0 from "./rp-users-datasources-list-cruds.vue?vue&type=style&index=0&id=0aa50926&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports